import { render } from "./post-smtp-card.vue?vue&type=template&id=ed21e76c&scoped=true"
import script from "./post-smtp-card.vue?vue&type=script&lang=js"
export * from "./post-smtp-card.vue?vue&type=script&lang=js"

import "./post-smtp-card.vue?vue&type=style&index=0&id=ed21e76c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed21e76c"],['__file',"src/components/post-smtp-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed21e76c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed21e76c', __exports__)) {
    api.reload('ed21e76c', __exports__)
  }
  
  module.hot.accept("./post-smtp-card.vue?vue&type=template&id=ed21e76c&scoped=true", () => {
    api.rerender('ed21e76c', render)
  })

}


export default __exports__